module.exports = __webpack_public_path__ + "static/media/score_points_icon_0e2c37_150.e8c72a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/score_points_icon_0e2c37_150.png
// module id = 586
// module chunks = 0